/** Reconcile authored guest counts with the room's configured capacity; keep bed counts intact. */
export function roomCapacityText(text: string | undefined, maxOccupancy: number): string {
  return (text || '').replace(
    /\bpara\s+(?:hasta\s+)?(?:\d+|una?|dos|tres|cuatro|cinco|seis|siete|ocho|nueve|diez)\s+(personas|hu[ée]spedes)\b/gi,
    `para hasta ${maxOccupancy} $1`,
  )
}
